import Accordion from "components/core/basic/Accordion";
import Card from "components/core/basic/Card";
import { Flex } from "../../../../styled-system/jsx";
import { useMutation } from "@tanstack/react-query";
import api from "utils/api";
import { successToast, errorToast } from "utils/toasts";
import { Button } from "components/core/basic/Button";
import { useAppSelector } from "redux/hooks";
import { css } from "../../../../styled-system/css";

const RefreshMarketplacesSection = () => {
  const user = useAppSelector((state) => state.user);

  const refreshMarketplacesHandler = useMutation({
    mutationFn: async () => {
      return await api.post("/api/manage/refresh_profiles/", {
        org: parseInt(user.organization_id),
        selected_profiles: [{ name: user.current_profile, type: user.organization_type }],
      });
    },

    onSuccess: () => {
      successToast({
        message: "Marketplaces Successfully Updated.",
      });
      setTimeout(() => {
        window.location.reload();
      }, 10000);
    },

    onError: (error) => {
      errorToast({
        message: "Failed to Refresh Marketplaces",
        error,
      });
    },
  });

  return (
    <Accordion title={"Refresh Marketplaces"}>
      <Card>
        <Flex className={css({ width: "100%", padding: "large" })} gap="small" justifyContent="center">
          <Button onPress={() => refreshMarketplacesHandler.mutate()}>Refresh Org Marketplaces</Button>
        </Flex>
      </Card>
    </Accordion>
  );
};

export default RefreshMarketplacesSection;
